// eslint-disable-next-line no-restricted-imports
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import ExpandIcon from './ExpandIcon';
import GameHeaderButton from '../../GameHeaderButton';

const ExpandButton = () => {
  const { setFullScreen } = useGameContext();
  return (
    <GameHeaderButton onClick={() => setFullScreen(true)}>
      <ExpandIcon />
    </GameHeaderButton>
  );
};

export default ExpandButton;
